import { render, staticRenderFns } from "./request-item.vue?vue&type=template&id=4cffc5f9&scoped=true&"
import script from "./request-item.vue?vue&type=script&lang=js&"
export * from "./request-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cffc5f9",
  null
  
)

export default component.exports